import { render, staticRenderFns } from "./ProjectSearchInput.vue?vue&type=template&id=146ac354&scoped=true&"
import script from "./ProjectSearchInput.vue?vue&type=script&lang=js&"
export * from "./ProjectSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSearchInput.vue?vue&type=style&index=0&id=146ac354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146ac354",
  null
  
)

component.options.__file = "ProjectSearchInput.vue"
export default component.exports